import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Card, Button, Select } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { setFilters } from "../currentAssetBalanceSlice";
import { fetchCurrentAssetBalance } from "../currentAssetBalanceThunk";
import { fetchCurrentAssetAccs } from "../../../../store/commonThunks/lookups";
import RecordDateFilter from "../../../../components/filters/RecordDateFilter";
import SearchListAutoComplete from "../../../../components/SearchListAutoComplete";
import { useDefaultDateRange } from "../../../../hooks/useDefaultDateRange";
import { useLocation, useSearchParams } from "react-router-dom";
import CommonDateRangeFilter from "../../../../components/common/filters/CommonDateRangeFilter";

const { Option } = Select;

const CurrentAssetBalanceFilters = ({ messageApi }) => {
  const dispatch = useDispatch();
  const { filters } = useSelector((state) => state.currentAssetBalance);
  const { curAssAccs = [], loading } = useSelector((state) => state.lookups);
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();

  // ✅ Auto set default date to today.
  // Must be declared before the drill-down effect below: effects run in
  // declaration order, and this one would otherwise overwrite the drill-down
  // dates with today's range.
  useDefaultDateRange(setFilters, filters, "today");

  // handleFilterChange only queues the update, so running the report right here
  // would still use the old (default) filters — flag it and run it from the
  // next effect, once the drill-down filters have been applied.
  const [drillReady, setDrillReady] = useState(false);
  useEffect(() => {
    const path = pathname.split("/")[3];
    if (path) {
      handleFilterChange("type", "Date Wise");
      handleFilterChange("toDate", path);
      handleFilterChange("fromDate", searchParams.get("fromDate") || undefined);
      setDrillReady(true);
    }
  }, []);
  useEffect(() => {
    if (drillReady) handleReport();
  }, [drillReady]);

  useEffect(() => {
    dispatch(fetchCurrentAssetAccs());
  }, [dispatch]);

  const handleFilterChange = (field, value) => {
    dispatch(setFilters({ [field]: value }));
  };

  const handleReport = () => {
    if (!filters.type) {
      messageApi.warning("Select Filter Type");
      return;
    }
    if (filters.type === "Current Asset Account Wise" && !filters.accId) {
      messageApi.warning("Select an Account");
      return;
    }
    dispatch(fetchCurrentAssetBalance(filters)).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        messageApi.success("Report loaded ✅");
      } else {
        messageApi.error("Failed to fetch records ❌");
      }
    });
  };

  return (
    <Card className="product-replace-filters mb-4 shadow-md rounded-xl">
      <Row
        gutter={[16, 16]}        
        align="middle"
        wrap
      >
        {/* Filter Type */}
        <Col xs={24} sm={12} md={12} lg={8} xl={6}>
          <label>Filter Type</label>
          <Select
            value={filters.type}
            onChange={(val) => handleFilterChange("type", val)}
            style={{ width: "100%" }}
          >
            <Option value="All Current Asset Account">
              All Current Asset Account
            </Option>
            <Option value="Current Asset Account Wise">
              Current Asset Account Wise
            </Option>
            <Option value="Date Wise">Date Wise</Option>
          </Select>
        </Col>

        {/* Account (if Account Wise) */}
        {filters.type === "Current Asset Account Wise" && (
          <Col xs={24} sm={12} md={12} lg={8} xl={6}>
            <label>Account</label>
            <SearchListAutoComplete
              optionsList={(curAssAccs || []).map((acc) => ({
                sale_id: acc.acc_id,
                display_text: acc.acc_name,
              }))}
              onSelect={(obj) => handleFilterChange("accId", obj?.sale_id)}
              placeholder="Current Asset Account"
              loading={loading.curAssAccs}
              showAddNew={false}
            />
          </Col>
        )}

        {/* Date filter (if Date Wise) */}
        {filters.type === "Date Wise" && (
          // <RecordDateFilter
          //   filters={filters}
          //   handleFilterChange={handleFilterChange}
          // />
          <CommonDateRangeFilter
            filters={filters}
            onChange={(fromDate, toDate) => {
            handleFilterChange("fromDate", fromDate);
            handleFilterChange("toDate", toDate);
            }}
          />
        )}

        {/* Report Button */}
        <Col
          xs={24}
          sm={12}
          md={8}
          lg={4}
          style={{ display: "flex", alignItems: "flex-end", height: 58 }}
        >
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleReport}
            block
            style={{height: 35.19}}
          >
            Report
          </Button>
        </Col>
      </Row>
      <style>{`
    @media (min-width: 768px) and (max-width: 1024px) {
      .product-replace-filters .ant-row .ant-col {
        flex: 0 0 50% !important;
        max-width: 50% !important;
      }
    }
      
}

  `}</style>
    </Card>
  );
};

export default CurrentAssetBalanceFilters;
